import React, { Component, useState, useRef } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'
import {
    SortableContainer, SortableElement, arrayMove, SortableHandle,
} from 'react-sortable-hoc'

import DragIcon from '../../assets/images/move-icon.svg'
import Checkbox from '../../components/form/Checkbox'
import Input from '../../components/form/Input'
import Button from '../../UniformComponents/Button'
import Tooltip from '../../UniformComponents/Tooltip'
import Menu from '../../UniformComponents/Menu'

const DragHandle = SortableHandle(() => (
    <div className="drag-handler">
        <img src={DragIcon} draggable="false" alt="drag icon" />
    </div>
))

const SortOption = SortableElement(({
    option,
    optInd,
    remOption,
    getMenu,
    getHeaderTitle,
    setHeaderTitle,
}) => {
    const optionRef = useRef(null)
    const menuList = getMenu(optInd)
    const [menuActive, setMenuActive] = useState(false)
    return (
        <div className="option-editor" ref={optionRef}>
            <div className="option">
                <div className="choice">
                    <DragHandle />
                    <Input
                        type="text"
                        cssClass="input"
                        placeholder={i18n.t('questionBuilder.optionEditor.option.placeholder', 'Enter option choice')}
                        defaultValue={getHeaderTitle(option.title)}
                        onBlur={({ value }) => {
                            setHeaderTitle(optInd, value)
                        }}
                    />
                </div>
                <React.Fragment>
                    {menuList.length > 0 && (
                        <Menu
                            cssClass={`option-menu ${menuActive ? 'active' : ''}`}
                            list={menuList}
                            width="495px"
                            dir="left"
                            showTick
                            onClose={() => {
                                setMenuActive((prevState) => !(prevState))
                            }}
                        >
                            <div
                                className="menu-icon"
                                onClick={() => {
                                    setMenuActive((prevState) => !(prevState))
                                }}
                            >
                                <i className="fa-regular fa-ellipsis-vertical" />
                            </div>
                        </Menu>
                    )}
                    <Tooltip
                        text={i18n.t('q_headerrow_delete')}
                        direction="bottom"
                        isNew
                    >
                        <i
                            className="del-icon fa-light fa-circle-xmark"
                            onClick={() => { remOption(optInd) }}
                        />
                    </Tooltip>
                </React.Fragment>
            </div>
        </div>
    )
})

const SortContainer = SortableContainer(({
    items,
    updateOption,
    remOption,
    getMenu,
    getHeaderTitle,
    setHeaderTitle,
}) => (
    <div id="sortable-container" className="option-list" style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
        {
            items.map((option, index) => (
                <SortOption
                    key={`item-${option.id}`}
                    index={index}
                    option={option}
                    optInd={index}
                    updateOption={updateOption}
                    remOption={remOption}
                    getMenu={getMenu}
                    getHeaderTitle={getHeaderTitle}
                    setHeaderTitle={setHeaderTitle}
                />
            ))
        }
    </div>
))

@observer
class HeaderGroups extends Component {
    constructor(props) {
        super(props)

        const { questionStore } = props
        const { question } = questionStore

        this.state = {
            enabled: question.hasHeaderGroup(),
        }
    }

    toggleGroupHeaders = ({ value }) => {
        const { questionStore } = this.props
        const { question } = questionStore
        if (!value) {
            question.headerGroups = []
            question.optionSet.options.forEach((option) => {
                Reflect.deleteProperty(option, 'headerGroupId')
            })
        } else {
            questionStore.addHeader()
        }
        this.setState({ enabled: value })
    }

    getOptionMenu = (index) => {
        const { questionStore } = this.props
        const { question } = questionStore
        const { headerGroups } = question

        const headerGroup = headerGroups[index]

        return [
            <div>
                <h5
                    style={{
                        margin: '0px',
                        borderBottom: '1px solid #F7F8FA',
                        paddingBottom: '5px',
                        marginBottom: '20px',
                    }}
                >
                    {i18n.t('q_headerrows_img')}
                </h5>
                <Input
                    type="text"
                    cssClass="input"
                    label="Image URL"
                    value={headerGroup.image}
                    onBlur={({ value }) => { headerGroup.image = value }}
                />
            </div>,
        ]
    }

    onSortEnd = ({ oldIndex, newIndex }) => {
        const { questionStore } = this.props
        const { question } = questionStore
        const { headerGroups } = question
        question.headerGroups = arrayMove(headerGroups.slice(), oldIndex, newIndex)
    }

    renderHeaders = () => {
        const { questionStore } = this.props
        const { question } = questionStore
        const { headerGroups } = question

        const headers = headerGroups || []

        return (
            <div key="sort-container">
                <SortContainer
                    items={headers}
                    onSortEnd={this.onSortEnd}
                    helperClass="option-drag"
                    lockAxis="y"
                    useDragHandle
                    lockToContainerEdges
                    getMenu={this.getOptionMenu}
                    remOption={questionStore.removeHeader}
                    getHeaderTitle={questionStore.getHeaderTitle}
                    setHeaderTitle={questionStore.setHeaderTitle}
                />
            </div>
        )
    }

    renderHeaderGroups = () => {
        const { enabled } = this.state
        const { questionStore } = this.props

        return (
            <div id="headergroup">
                <Checkbox
                    name="headerGroups"
                    label={i18n.t('q_headerrows_label')}
                    defaultChecked={enabled}
                    onBlur={this.toggleGroupHeaders}
                />
                {enabled && (
                    <div
                        style={{
                            background: '#F7F8FA',
                            borderRadius: '8px',
                            padding: '10px',
                            marginTop: '10px',
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '10px',
                        }}
                    >
                        {this.renderHeaders()}
                        <Button
                            cssClass="regular primary"
                            icon="fa-regular fa-octagon-plus"
                            label={i18n.t('q_headerrows_add')}
                            onClick={questionStore.addHeader}
                            style={{ width: 'fit-content' }}
                        />
                    </div>
                )}
            </div>
        )
    }

    render() {
        return this.renderHeaderGroups()
    }
}

export default HeaderGroups
